import { i18n } from "@lingui/core";

import { useGameStore } from "./state/store";

export const locales = ["ru", "en"] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "ru";

export const localeLabels: Record<Locale, string> = {
  ru: "Русский",
  en: "English",
};

export async function activateLocale(locale: Locale): Promise<void> {
  const { messages } = await import(`./locales/${locale}/messages.po`);
  i18n.load(locale, messages);
  i18n.activate(locale);
  if (typeof document !== "undefined") {
    document.documentElement.lang = locale;
  }
}

/** Activates the locale persisted in the settings store (default "ru"). */
export async function initI18n(): Promise<void> {
  await activateLocale(useGameStore.getState().settings.language);
}
